<template>
  <div>
    <Multiselect
      class="w100p"
      :value="language"
      :options="languages"
      :searchable="false"
      :allow-empty="false"
      :show-labels="false"
      label="name"
      track-by="alpha_2"
      placeholder="Select a language"
      @select="onSelect"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"

export default {
  name: "LanguageSelector",
  props: {
    post: {
      default: true,
      type: Boolean
    }
  },
  methods: {
    onSelect: function (language) { this.setLanguage({ language, post: this.post }) },
    ...mapActions("members", ["getLanguages", "setLanguage"])
  },
  computed: {
    ...mapState("members", ["languages", "language"])
  },
  mounted: function () { this.getLanguages() }
}
</script>
